module.exports = __webpack_public_path__ + "img/s5.f1b94a11.svg";